import {
  type PayloadAction,
  createAsyncThunk,
  createSlice
} from '@reduxjs/toolkit';

import { requestsApi } from '@/api/requests.api';
import type {
  IAcceptResponseBody,
  ICancelResponseBody,
  IRequestInfo
} from '@/api/types/requests.types';

import type { TRootState } from './store';

export const getRequestInfo = createAsyncThunk(
  'autoCreditOffers/getRequestInfo',
  (requestId: string, { getState }) => {
    const state = getState() as TRootState;
    const isLeasing = state.app.productType === 'leasing';
    if (isLeasing) {
      return requestsApi.getLeasingRequestInfo(requestId);
    }
    return requestsApi.getRequestInfo(requestId);
  }
);

export const acceptResponse = createAsyncThunk(
  'autoCreditOffers/acceptResponse',
  async (body: IAcceptResponseBody, { dispatch }) => {
    const response = await requestsApi.acceptResponse(body);
    dispatch(getRequestInfo(body.requestId));
    return response;
  }
);

export const cancelResponse = createAsyncThunk(
  'autoCreditOffers/cancelResponse',
  async (body: ICancelResponseBody, { dispatch }) => {
    const response = await requestsApi.cancelResponse(body);
    dispatch(getRequestInfo(body.requestId));
    return response;
  }
);

interface IAutoCreditOffersState {
  requestInfo: IRequestInfo | null;
}

const initialState: IAutoCreditOffersState = {
  requestInfo: null
};

const autoCreditOffersSlice = createSlice({
  name: 'autoCreditOffers',
  initialState,
  reducers: {
    setRequestInfo: (state, action: PayloadAction<IRequestInfo | null>) => {
      state.requestInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getRequestInfo.fulfilled, (state, action) => {
      state.requestInfo = action.payload;
    });
  }
});

export const { setRequestInfo } = autoCreditOffersSlice.actions;

export default autoCreditOffersSlice;
